module.exports = __webpack_public_path__ + "static/media/PF-2010CSumidero.9abf1a9b.png";